<template>
    <div class="modelList_box">
        <div class="app_container">
            <div class="modelList_header">
                <ul class="modelList_items">
                    <li class="modelList_item" v-for="(city,index) in cityPLists" v-bind:key="index">
                        <div class="modelList_thumbnails project_img_box" v-if="!city.off_thumb" v-bind:style="{backgroundImage:'url(\''+ processingUrl(city.picPath) +'\'),url(../../static/img/scene-default1.png)'}" v-on:click="viewCity(city,index,true,city.off_template)" title="预览地图">
                            <div class="top_left tooltip-box top" data-content="公开地图" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #1a8cd8;" v-show='false'>
                                <img src="../../static/img/map.svg" />
                            </div>
                            <span class="indexAPP" @click.stop="viewCity(city,index,true,city.off_template)"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in city.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="city.off_template" @click.stop="showPurchaseTips(city)">购买</div>
                        </div>
                        <div class="modelList_thumbnails project_img_box" v-if="city.off_thumb" v-bind:style="{backgroundImage:'url(\''+ city.off_thumb +'\'),url(../../static/img/scene-default1.png)'}" v-on:click="viewCity(city,index,true,false)" title="预览地图">
                            <div class="top_left tooltip-box top" data-content="公开地图" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip" style="background: #1a8cd8;" v-show='false'>
                                <img src="../../static/img/map.svg" />
                            </div>
                            <span class="indexAPP" @click.stop="viewCity"><i>{{index+1}}</i></span>
                            <div id="model_keyword">
                                <ul>
                                    <li v-html="$options.filters.highLightkeyWord(keyword)" v-if="$options.filters.highLightkeyWord(keyword)" v-for="(keyword) in city.keyWordArr" v-bind:key="keyword">{{keyword}}</li>
                                </ul>
                            </div>
                            <div class="isPay" v-if="city.isShopping==1" @click.stop="saleItem(city)">购买</div>
                        </div>
                        <hr/>
                        <div class="modelList_info projectList_info">
                            <div class="author_info city_author_info">
                                <a class="tooltip-box top" style = "cursor:auto">
                                    <img class="author_headImg" v-bind:src="disposeUrl(city.map,city.author)">
                                </a>
                                <span class="author_name" style="max-width:200px;" v-on:click="viewCity(city,index,false,city.off_template)" v-html="$options.filters.highLightMsg(city.name)" v-bind:title="city.name" @dblclick="selectText()">{{city.name}}</span>
                            </div>
                            <div class="model_info">
                                <div class="model_seen model_time tooltip-box top"  v-bind:data-content="processingTime(city.modifyTime,city.off_template?true:false)" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-calendar fa-fw"></i>
                                </div>
                                <div class="model_price tooltip-box top" v-if="city.off_template" data-content="城市售价" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-yen fa-fw"></i>{{city.price}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="数据大小" v-if="!city.off_template" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-file-archive-o"></i>{{formatBytes(city.projectSize)}}
                                </div>
                                <div class="model_seen tooltip-box top" data-content="浏览次数" v-on:mouseenter="showTooltip" v-on:mouseleave="cancelTooltip">
                                    <i class="fa fa-eye fa-fw"></i>{{formatNumber(city.view)}}
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modelList_footer">
                <h4 class="text_muted" v-if="!isLoadComplete">加载中...</h4>
				<div class="load_more_btn" v-on:click="loadMore" v-if="!isLastPage&&isLoadComplete">加载更多<i class="fa fa-arrow-circle-o-down"></i></div>
				<h4 v-if="isLastPage" class="text_muted">已显示全部</h4>
			</div>
            <div id="list_info" class="modelList_infoShow_max cityShow" v-show="infoShow">
                <div id="info_top" class="info_top">
                    <span class="info_title">地图浏览：{{message.name}}<i>（{{index+1}}/{{cityListNum}}）</i></span>
                    <span class="zoom_window" v-on:click="zoomdiv" href="javascript:;"><img class="zoom_icon" src="../../static/img/最小化.png" alt="shrink"></span>
                    <span id="close_icon" class="layui-layer-setwin" v-on:click="closediv"><a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a></span>
                </div>
                <div id="info_bottom" class="info_bottom_max">
                    <span class="fullScreenClose" v-on:click="closediv"></span>
                    <iframe id="myframeC" v-if="infoShow" v-bind:src="this.viewPath+'&id='+message.code" frameborder="0" style="width:100%;height:100%;"></iframe>
                    <span class="fullScreen" v-on:click="large()" style="bottom:55px;"></span>
                </div>
            </div>
            <div class="popContainer" v-show="infoShow"></div>
        </div>
        <!-- <div id="boxHeader">
          <ModelService @hidePanel=hidePanel v-show="panelShow" :panelShow="panelShow"></ModelService>
        </div> -->
        <purchaseTips ref="purchaseTips"></purchaseTips>
    </div>
</template>
<script>
    import bus from '../assets/js/eventBus.js';
    import crypto from 'crypto-browserify';
    import Identicon from 'identicon.js';
    import shield from '../assets/js/shield.js';
    import ModelService from './ModelService.vue';
    import purchaseTips from './panelTips/purchaseTips.vue';
    var vm;
    export default {
        nanme:"city_box",
        components:{
            ModelService,
            purchaseTips
        },
        data:function(){
            return {
                Path: "https://www.thingjs.com/citybuilder_console/",
                viewPath:"https://www.thingjs.com/citybuilder/#/projectPreview?model=preview&logo=false&template=false",
                imgPath : "https://www.thingjs.com",
                showList:[],
                queryData: {
                    type:"",
                    bigType: "",
                    smallType: "",
                    keyWord: "",
                    pageSize: 24,
                    pageNumber: 1,
                    sort: "zonghe"
                },
                isLastPage:false,
                message:[],
                infoShow:false,
                cityListNum:'',
                index:0,
                isLoadComplete :false,
                panelShow:false,
                openUrl:'',
                sceneListType:''
            };
        },
        methods:{
            selectText(){
                document.getSelection().selectAllChildren(document.getSelection().focusNode.parentNode);
                document.execCommand('copy');
            },
            disposeUrl:function(url,userNick){
                if(!!url){
                    var urlHeader = url.substring(0,4);
                    if(urlHeader == 'http'){
                        return url;
                    }else{
                        return this.imgPath + url;
                    }
                }else{
                    if(userNick == null){
                        userNick = 'thingjs';
                    }
                    var hash = crypto.createHash('md5');
                    hash.update(userNick);
                    var imgData = new Identicon(hash.digest('hex')).toString();
                    var imgUrl = 'data:image/png;base64,'+imgData;
                    return imgUrl;
                return imgUrl;
                    return imgUrl;
                }
            },
            formatBytes:function(bytes, decimals) {
                if (bytes === 0) return ' -- ';
                var k = 1024;
                var dm = decimals < 0 ? 0 : decimals;
                var sizes = ['B', 'K', 'M', 'G', 'T', 'PB', 'EB', 'ZB', 'YB'];
                var i = Math.floor(Math.log(bytes) / Math.log(k));
                return ' ' + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
            },
            queryCitylList:function(data,type="mmdMap"){
                var _this = this;
                var _list = this.showList;
                _this.isLoadComplete = true;
                _this.sceneListType = type;
                var url = '/scene/city';
                // var url = '';
                // if(type == "mmdMap") return;
                if(type =='templateMap'){
                    url = '/scene/cityTemplate';
                }
                this.$reqs.post(url, data).then(function(result) {
                    if(result.data && result.data.success=='1') {
                        var content = result.data.data.list;
                        var contentLen = content.length;
                        bus.$emit('changeListCount',result.data.data.pager.recordCount);
                        if(result.data.data.search){
                            bus.$emit('lockScroll',true);
                        }
                        _this.cityListNum = result.data.data.pager.recordCount;
                        for(var i = 0; i < contentLen; i++) {
                            _list.push(content[i]);
                        }
                        _this.isLastPage = result.data.data.pager.recordCount <= result.data.data.pager.pageNumber*result.data.data.pager.pageSize;
                    }else{
                        console.log('queryCityList error');
                    }
                }).catch(function(error) {
                    console.log('queryCityList error'+error);
                });
            },
            showTooltip: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
            },
            cancelTooltip: function(event) {
                $("div").remove(".tooltips");
            },
            showTooltip1: function(event) {
                var content = $(event.target).data("content");
                var tipEle ='<div class="tooltips"><div class="arrow"></div>' + content +'</div>';
                $(event.target).append(tipEle);
                var leftPx = Number('-' + parseInt($('.tooltips').width())/2);
                $('.modelList_info .city_author_info .top .tooltips').css({
                    "left":leftPx,
                    "transition-duration":"0s"
                });
            },
            cancelTooltip1: function(event) {
                $("div").remove(".tooltips");
                $('.modelList_info .city_author_info .top .tooltips').css({
                    "left":"0px",
                    "transition-duration":"0s"
                });
            },
            formatNumber: function(number) {
                if(number < 1000) {
                    return number;
                } else {
                    return(number / 1000).toFixed(1) + "k";
                }
            },
            loadMore: function() {
                this.queryData.pageNumber++;
                this.queryCitylList(this.queryData,this.sceneListType);
            },
            processingUrl:function(path){
                if(path.indexOf('http')!=-1) {
                    return path;
                } else {
                    var backPath = path.toString().replace(/\\/g, "/");
                    return this.Path+backPath;
                }
            },
            processingTime: function(time,type) {
                var str = time.toString();
                if(type) return str
                var str = time.toString();
                var year = str.substring(0,4);
                var mon = str.substring(4,6);
                var day = str.substring(6,8);
                var hour = str.substring(8,10);
                var min = str.substring(10,12);
                var sec = str.substring(12,14);
                var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
                return dateStr;
            },
            zoomdiv:function(){
                let zoomicon = document.getElementsByClassName('zoom_icon')[0];
                let listInfo = document.getElementById('list_info');
                let infoBottom = document.getElementById('info_bottom');
                if(zoomicon.alt == "shrink"){
                    listInfo.className = 'modelList_infoShow cityShow';
                    infoBottom.className = 'info_bottom';
                    $('.kefuBtn').show();
                    $('.qqBtn').show();
                    $('.wxBtn').show();
                    zoomicon.src = "../../static/img/最大化.png";
                    zoomicon.alt = "maximize";
                }else if(zoomicon.alt == "maximize"){
                    listInfo.className = 'modelList_infoShow_max cityShow';
                    infoBottom.className = 'info_bottom_max';
                    $('.kefuBtn').hide();
                    $('.qqBtn').hide();
                    $('.wxBtn').hide();
                    zoomicon.src = "../../static/img/最小化.png";
                    zoomicon.alt = "shrink";
                }
            },
            closediv:function(){
                $('.kefuBtn').show();
                $('.qqBtn').show();
                $('.wxBtn').show();
                if($(".fullScreen").hasClass("tuichu")){
                    this.large();
                }
                this.infoShow = false;
            },
            viewCity:function(city,index,flag,isTemplate){
                // if(flag){
                //     var msg = {title:'预览项目',subject:'cityList',toolInfo:{data:city}};
                //     bus.$emit('view',msg);
                //     return
                // }
                var _this = this;
                if($.cookie('openid')){
                    if(isTemplate){
                        if(city.attributeStore && city.attributeStore.resourceId){
                            let resourceId = city.attributeStore.resourceId;
                            var openUrl ='https://city.thingjs.com/preview/' + resourceId;
                            window.open(openUrl,"_blank");
                            // 增加预览次数
                            _this.$reqs.get("/scene/addCityTemplateView?id="+city.id).then(function(result) {})
                        }
                    }else{
                        $.ajax({
                            url:_this.Path+'mapProject/uploadCjs?name=&originProjectId=&projectId=' + city.code,
                            type:'post',
                            data:{
                                projectId: city.code
                            },
                            headers: {
                                'openid': getCookie('openid', true),
                                'token': getCookie('token')
                            },
                            dataType:'json',
                            success: function (d) {
                                if (d.success == 1 && d.data && d.data.fixedCjsPath) {
                                    var fPath = d.data.fixedCjsPath;
                                    var mmdId = getCookie("mmdId");
                                    var mapName =city.name;
                                    var reData = {
                                        'type': 'city',
                                        'preUrl': fPath,
                                        'name': mapName,
                                        'mmdId': mmdId,
                                        'bgimg':city.off_thumb?city.off_thumb:_this.processingUrl(city.picPath)
                                    }
                                    let isMmdidLegitimate;
                                    try{
                                        isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                                    }catch(e){
                                        isMmdidLegitimate = true;
                                    }
                                    if(isMmdidLegitimate){
                                        _this.$reqs.post("/api/getPreviewUrl",reData).then(function(result) {
                                            if(result.data && result.data.state) {
                                                var openUrl ='https://www.thingjs.com' + result.data.content;
                                                window.open(openUrl,"_blank");
                                            } else {
                                                console.log("获取地址失败！");
                                            }
                                        }).catch(function(error) {
                                            console.log("获取地址失败！"+error);
                                        });
                                    }
                                }
                            }
                        });
                    }
                }else{
                    logoinForStore();
                }
            },
            large:function(){
                var _this = this;
                var parentF = '';
                var id = '';
                parentF = ".modelList_infoShow";
                id = "#myframeC";
                if($(".fullScreen").hasClass("tuichu")){
                    $(parentF).removeClass("quanping");
                    $(id).removeClass("fullFrame");
                    $(".fullScreen").removeClass("tuichu");
                    $("html").css("overflow-y","scroll");
                    $(".popContainer").show();
                    $(".fullScreenClose").hide();
                    // $('.navHeader').hide();
                }else{
                    $(".fullScreen").addClass("tuichu");
                    $(parentF).addClass("quanping");
                    $(id).addClass("fullFrame");
                    $("html").css("overflow-y","hidden");
                    $(".fullScreenClose").show();
                    $(".popContainer").hide();
                    $('.navHeader').show();
                }
            },
            saleItem(city,flag = true) {
                // console.log('购买项目4')
                if(flag){
                    var msg = {title:"购买项目",subject:'project_buy_city',toolInfo:{data:city}};
                    bus.$emit('view',msg);
                    return
                }
                if($.cookie('openid')){
                    // this.panelShow = true;
                    var name = city.projectName?city.projectName:city.name;
                    var msg = {
                        "subject":'saleProject',
                        "projectName":"购买项目："+name,
                         type:'ThingJS_ForCity',
                         id:city.code
                    }
                    var _this = this;
                    $.ajax({
                        url:_this.Path+'mapProject/uploadCjs?name=&originProjectId=&projectId=' + city.code,
                        type:'post',
                        data:{
                            projectId: city.code
                        },
                        headers: {
                            'openid': getCookie('openid', true),
                            'token': getCookie('token')
                        },
                        dataType:'json',
                        success: function (d) {
                            if (d.success == 1 && d.data && d.data.fixedCjsPath) {
                                var fPath = d.data.fixedCjsPath;
                                var mmdId = getCookie("mmdId");
                                var mapName =city.name;
                                var reData = {
                                    'type': 'city',
                                    'preUrl': fPath,
                                    'name': mapName,
                                    'mmdId': mmdId,
                                    'bgimg':city.off_thumb?city.off_thumb:_this.processingUrl(city.picPath)
                                }
                                let isMmdidLegitimate;
                                try{
                                    isMmdidLegitimate = this.$global.AntiSqlValid(mmdId);
                                }catch(e){
                                    isMmdidLegitimate = true;
                                }
                                if(isMmdidLegitimate){
                                    _this.$reqs.post("/api/getPreviewUrl",reData).then(function(result) {
                                        if(result.data && result.data.state) {
                                            msg.url ='https://www.thingjs.com' + result.data.content;

                                        } else {
                                            msg.url = ''
                                            console.log("获取地址失败！");
                                        }
                                        bus.$emit("sales",msg);
                                        // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                    }).catch(function(error) {
                                        console.log("获取地址失败！"+error);
                                        msg.url = '';
                                        bus.$emit("sales",msg);
                                        // window.parent.postMessage({"type":"saleProject","msg":msg},'*');
                                    });
                                }
                            }
                        }
                    });
                }else{
                    logoinForStore();
                }
            },
            hidePanel:function(success) {
                var _this = this;
                this.panelShow = false;
            },
            showPurchaseTips(item){
                if($.cookie('openid')){
                    if(item.price === 0){
                        let datas ={
                            'cont':'当前城市为免费城市，您确定复制此城市吗？',
                            'item':item,
                            'type':'map_plate',
                        }
                        this.$refs.purchaseTips.getContentFrom(datas);
                    }else{
                        this.buyCityProgress(item);
                    }
                }else{
                    logoinForStore();
                }
            },
            buyCityProgress(scene){
                var userId = $.cookie('mmdId');
                let typs = 'ThingStore_City';
                let tOrderId = userId + "."+ typs +"." + scene.id;
                layer.open({
                    type: 2,
                    title: false,
                    closeBtn: 0,
                    area: ['585px', '568px'],
                    // content: ['http://127.0.0.1/guide/createPay/payment.html?type=shop&userId='+userId,'no'],
                    content: ['https://www.thingjs.com/static/payment/createPay/paymentOrder.html?type='+typs+'&userId='+userId+'&tOrderId=' + tOrderId,'no'],
                    skin: 'buyShopDiv',
                    success:function(){
                        document.getElementsByClassName('buyShopDiv')[0].querySelector('.layui-layer-content').children[0].contentWindow.postMessage({paySource:location.href}, '*');

                        // document.getElementsByClassName('buyShopDiv')[0].children[1].children[0].contentWindow.postMessage(dataArr,'*');
                        // scene.step = '';
                    }
                });
                window.addEventListener('message',function(event){
                    if(event.data&&event.data.type&&event.data.type=="newStyle") {
                        $(".buyShopDiv").css({"border-radius":"8px","background-color": "transparent"});
                        $(".buyShopDiv iframe").css("border-radius","8px");
                    }
                    if(event.data=='close'){
                        layer.closeAll();
                    }
                    if(event.data=='success'){
                        layer.closeAll();
                        window.AnalysysAgent && window.AnalysysAgent.track('source_pay_success',{
                            'buyPackageName': dataArr.title
                        })
                    }
                });
            }
        },
        computed: {
            cityPLists(){
                let arr=[];
                let _this = this;
                if(_this.sceneListType && _this.sceneListType == 'templateMap'){
                    for(let i in _this.showList){
                        let curI = _this.showList[i];
                        if(curI.off_template){
                            arr.push(curI);
                        }
                    }
                }else{
                    for(let i in _this.showList){
                        let curI = _this.showList[i];
                        if(!curI.off_template){
                            arr.push(curI);
                        }
                    }
                }
                return arr;
            }
        },
        beforeCreate() {
            vm = this;
        },
        beforeDestroy(){
            bus.$off("mapListChangeEvent");
            bus.$off("addCitylList");
            bus.$off("changeCityList");
            bus.$off("showCityNull");
        },
        mounted(){
            var _this = this;
            if(shield.shieldWords.indexOf($("#keyword").val())=='-1'){
                this.queryData.keyWord = $("#keyword").val();
            }
            this.queryData.sort = $('.active').attr('data-sort');
            this.queryCitylList(this.queryData,this.sceneListType);
            bus.$on("mapListChangeEvent", (id) => {
                this.showList = [];
                this.queryCitylList(this.queryData,id);
            });
            bus.$on("changeCityList",(data) =>{
                this.showList = [];
                this.queryCitylList(data,this.sceneListType);
                this.queryData = JSON.parse(JSON.stringify(data));
            });
            bus.$on("showCityNull",(data) =>{
                this.showList = [];
                bus.$emit('changeListCount','-1');
                this.isLastPage = true;
            });
            bus.$on("addCitylList", (data) => {
                _this.queryData.pageNumber++;
                this.queryCitylList(_this.queryData,this.sceneListType);
            });
            bus.$on("cityList",(data) => {
                this.viewCity(data,false);
            })
            // city.vue
            bus.$on("project_buy_city",(data) => {
                this.saleItem(data,false);
            })
        },
        filters:{
            highLightMsg:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return value;
                        // return value.length>7 ? value.substring(0, 7)+"..." : value;
                    }
                }else{
                    return value;
                    // return value.length>7 ? value.substring(0, 7)+"..." : value;
                }
            },
            highLightkeyWord:function(value){
                if(vm.queryData && vm.queryData.keyWord){
                    var reg = new RegExp(vm.queryData.keyWord,"g");
                    if(value.indexOf(vm.queryData.keyWord) != -1){
                        return value.replace(reg,'<span class="highlight">'+vm.queryData.keyWord+'</span>')
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/City.vue